module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/_redefine.js
// module id = 1RnF
// module chunks = 11